import React, { useContext } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { LocalizeContext } from 'react-locale-language';
import CemeteryButton from './CemeteryButton';
import DialogModal from '../../../../common/DialogModal/DialogModal';

const ArchivedStrategySection = ({
  title,
  strategies = [],
  onStrategyClick,
  onRetreiveClick,
  onEditClick,
  onDeleteClick,
  translate
}) => (
  <Card className="mb-3">
    <Card.Header className="bg-dark">
      <h5 className="mid text-white text-center fw-bold mb-0">{title}</h5>
    </Card.Header>
    {strategies.length > 0 ? (
      <Card.Body className="bg-light pt-1">
        <Row>
          {strategies.map(strategy => (
            <Col xs={12} md={6} key={strategy._id} className="mt-3">
              <CemeteryButton
                strategy={strategy}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                onStrategyClick={onStrategyClick}
                onRetreiveClick={onRetreiveClick}
              />
            </Col>
          ))}
        </Row>
      </Card.Body>
    ) : (
      <Card.Body>
        <h5 className="mid text-muted text-center p-5 mb-0">{translate('nothing_to_show')}</h5>
      </Card.Body>
    )}
  </Card>
);

const Cemetry = ({ strategies = [], onStrategyClick, onRetreiveClick, onEditClick, onDeleteClick, translate }) => {
  const strategistStrategies = strategies.filter(s => !s.isSandboxed);
  const diyStrategies = strategies.filter(s => s.isSandboxed);

  return (
    <div className="p-3">
      <ArchivedStrategySection
        title={translate('strategist_strategies')}
        strategies={strategistStrategies}
        onStrategyClick={onStrategyClick}
        onRetreiveClick={onRetreiveClick}
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        translate={translate}
      />
      <ArchivedStrategySection
        title={translate('diy_strategies')}
        strategies={diyStrategies}
        onStrategyClick={onStrategyClick}
        onRetreiveClick={onRetreiveClick}
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        translate={translate}
      />
    </div>
  );
};

const CemetryDialog = ({ strategies, show, onHide, onRetreiveClick, onEditClick, onDeleteClick, onStrategyClick }) => {
  const { translate } = useContext(LocalizeContext);
  return (
    <DialogModal visible={show} onClose={onHide} title={`${translate('strategy_archive')}`} maxWidth="lg">
      {show && (
        <Cemetry
          strategies={strategies}
          onRetreiveClick={onRetreiveClick}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
          onStrategyClick={onStrategyClick}
          translate={translate}
        />
      )}
    </DialogModal>
  );
};

export default CemetryDialog;
